<template>
    <vs-popup class="manage-indirect-channel" id="popup" :title="'CREATE CUSTOMER FOR CHANNEL'" @close="open = false"
        :active.sync="open" :buttons-hidden="true">
        <vx-card no-shadow style="line-height: 2;" class="font-bold text-primary text-xl">
            Partner Code: {{ channel_partner_data.code }} <br>
            Channel Partner Name: {{ channel_partner_data.company_name }}
        </vx-card>
        <!-- create mode enable -->
        <vx-card no-shadow>
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <form id="create-marketing-lead-popup" autocomplete="off" @submit.prevent="handleSubmit(onClickSubmit)">
                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/3 md:mb-0">
                            <ValidationProvider vid="customer_id" name="customer_id" rules="required" v-slot="{ errors }">
                                <small class="label">Customer</small>
                                <v-select :clearable="false" name="customer_id" placeholder="" label="company_name"
                                    :reduce="option => option.id" v-model="form.customer_id" :options="customer_list"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <vx-card noShadow cardBorder title="Products & Agreements">
                        <div class="mb-3 vx-row" v-for="(product, index) in form.products" :key="`product_${index}`">
                            <div class="vx-col md:w-1/5 w-full md:mb-0">
                                <ValidationProvider :vid="`formulation_id_${index}`" :name="`formulation_id_${index}`"
                                    rules="required" v-slot="{ errors }">
                                    <small class="label">Product</small>
                                    <v-select @input="onInputProductRow(product, index)" :clearable="true"
                                        :closeOnSelect="true" :name="`formulation_id_${index}`" placeholder="" label="name"
                                        v-model="product.formulation_id" :reduce="option => option.id"
                                        :options="product_list" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                        <template slot="option" slot-scope="option">
                                            <span>{{ option.formulation_code }} - {{ option.name }}</span>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <span>{{ option.formulation_code }} - {{ option.name }}</span>
                                        </template>
                                    </v-select>
                                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="w-full vx-col md:w-1/5 md:mb-0">
                                <ValidationProvider :vid="`date_introduced_${index}`" :name="`date_introduced_${index}`"
                                    rules="required" v-slot="{ errors }">
                                    <small class="label">Date Introduced</small>
                                    <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="w-full hidden"
                                        v-model="product.date_introduced" placeholder="Choose Date" />
                                    <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="w-full"
                                        v-model="product.date_introduced" placeholder="Choose Date" />
                                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="w-full vx-col md:w-1/5 md:mb-0">
                                <ValidationProvider :vid="`start_date_${index}`" :name="`start_date_${index}`"
                                    rules="required" v-slot="{ errors }">
                                    <small class="label">Agreement Start Date</small>
                                    <flat-pickr :config="{ dateFormat: 'd/m/Y' }"
                                        class="w-full hidden" v-model="product.start_date" placeholder="Choose Date" />
                                    <flat-pickr @input="onInputProductRow(product, index)"
                                        :config="{ dateFormat: 'd/m/Y' }" class="w-full"
                                        v-model="product.start_date" placeholder="Choose Date" />
                                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="w-full vx-col md:w-1/5 md:mb-0">
                                <ValidationProvider :vid="`end_date_${index}`" :name="`end_date_${index}`"
                                    rules="required" v-slot="{ errors }">
                                    <small class="label">Agreement End Date</small>
                                    <flat-pickr :config="{  dateFormat: 'd/m/Y' }"
                                        class="w-full hidden" v-model="product.end_date" placeholder="Choose Date" />
                                    <flat-pickr @input="onInputProductRow(product, index)"
                                        :config="{ dateFormat: 'd/m/Y' }" class="w-full"
                                        v-model="product.end_date" placeholder="Choose Date" />
                                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="w-full vx-col md:w-1/5 md:mb-0">
                                <div class="vx-row">
                                    <div class="w-full vx-col md:w-4/5 md:mb-0">
                                        <ValidationProvider :vid="`percent_${index}`" :name="`percent_${index}`"
                                            rules="required" v-slot="{ errors }">
                                            <small class="label">Commission Percentage (%)</small>
                                            <vs-input v-model="product.percent" :name="`percent_${index}`" class="w-full"
                                                label="" :danger="!!errors[0]" :danger-text="errors[0]"
                                                val-icon-danger="icon-x" val-icon-pack="feather" />
                                        </ValidationProvider>
                                    </div>
                                    <div class="w-full vx-col md:w-1/5 md:mb-0">
                                        <vs-button class="mt-8" size="small" icon-pack="feather" icon="icon-x"
                                            :disabled="form.products.length === 1"
                                            color="danger" @click.stop="onClickRemoveProduct(index)"></vs-button>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-row mb-8 mt-1" v-if="product.errors.length > 0">
                                <div class="vx-col w-full px-8">
                                    <vs-alert class="mt-1 font-bold w-full" color=danger
                                        title="This product is already linked to another customer" icon-pack="feather"
                                        icon="icon-info">
                                        Product: {{ product.errors[0].formulation_code }} |
                                        Agreement Code: {{ product.errors[0].code }} | Customer Name: {{
                                            product.errors[0].customer_name }} | Agreement Start Date: {{
                                            product.errors[0].start_date }} | Agreement End Date: {{
                                            product.errors[0].end_date }}
                                    </vs-alert>
                                </div>
                            </div>
                        </div>
                        <vs-button @click.stop="onClickAddProduct" class="mt-8" size="small" icon-pack="feather"
                            icon="icon-plus" color="primary">add</vs-button>
                    </vx-card>

                    <!-- Save & Reset Button -->
                    <div class="flex flex-wrap items-center justify-end mt-8">
                        <vs-button button="submit" class="mt-2 ml-auto">Save
                            Changes</vs-button>
                    </div>

                </form>
            </ValidationObserver>
        </vx-card>
    </vs-popup>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const CrmRepository = RepositoryFactory.get('crm');
import CustomerDropdown from "@/components/drop-down-filters/CustomerDropdown";
const DropDownRepository = RepositoryFactory.get('drop_down')
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
    return {
        open: false,
        form: {
            customer_id: null,
            products: [
                { formulation_id: null, date_introduced: null, start_date: null, end_date: null, percent: 0, errors: [] }
            ],
        },
        channel_partner_data: {
            code: '',
            company_name: ''
        },
        id: null,
        indirect_channels: [],
        is_on_create_mode: false,
        create_type: '',
        selected_channel: null,
        customer_list: [],
        product_list: [],
    }
}

export default {
    name: 'CreateCustomerForIndirectChannelPartnerPopUp',
    data() {
        return initialState()
    },
    components: {
        flatPickr,
        'v-select': vSelect,
        CustomerDropdown
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
        async openPopup(id) {
            try {
                await Object.assign(this.$data, initialState());
                this.open = true
                this.id = id
                await this.fetchProducts()
                await this.fetchIncotermDetails()
                await this.fetchCustomers()
            } catch (e) {

            }
        },
        onClickAddProduct() {
            this.form.products.push({ formulation_id: null, date_introduced: null, start_date: null, end_date: null, percent: 0, errors: [] })
        },
        onClickRemoveProduct(index) {
            this.form.products.splice(index, 1)
        },
        async fetchIncotermDetails() {
            await this.$vs.loading({
                container: '#create-marketing-lead-popup',
                scale: 0.45
            })
            try {
                const { data } = (await CrmRepository.getIndirectChannelDetails(this.id)).data
                this.indirect_channels = data.customers
                this.channel_partner_data = data
            } catch (e) {
                this.convertAndNotifyError(e)
            }
            this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
        },
        async fetchCustomers() {
            try {
                const { data } = (await DropDownRepository.getCustomersList('filter[status]=Approved')).data
                const existing_customer_ids = this.indirect_channels.map((x) => x.customer_id)
                this.customer_list = data.filter((x) => !existing_customer_ids.includes(x.id))
            } catch (error) {

            }
        },
        async fetchProducts() {
            try {
                const { data } = (await DropDownRepository.getFormulationList('filter[status]=Production')).data
                this.product_list = data
            } catch (error) {

            }
        },
        async onClickSubmit() {
            try {
                this.form.products = this.form.products.map((x) => {
                    x.percent = Number(x.percent).toFixed(2)
                    return x
                })
                await CrmRepository.createIndirectChannelCustomer(this.id, [this.form])
                this.showSuccessMessage('Customer added successfully!')
                this.open = false
                this.$emit('openManageChannel', this.id)
                // if (this.create_type === 'lead') {
                //     await CrmRepository.createCrmIndirectChannel(this.id, [this.form])
                // }
                // if (this.create_type === 'channel') {
                //     await CrmRepository.createCrmIndirectChannelCommission(this.selected_channel.id, this.form)
                //     this.selected_channel = null
                // }
                // this.is_on_create_mode = false
                this.form = {}
                await this.fetchIncotermDetails()
            } catch (error) {
                if (error.response.data.data.customers.length > 0) {
                   
                } else {
                    this.convertAndNotifyError(error)
                }
            }
        },
        async onInputProductRow(row_data, index) {
            if (row_data.formulation_id && row_data.start_date && row_data.end_date) {
                const params = `from=${row_data.start_date}&to=${row_data.end_date}&formulation-id=${row_data.formulation_id}`
                const { data } = await CrmRepository.checkProductAvailability(params)
                this.form.products[index].errors = data.data
            }
        }
    }
}
</script>
<style scoped>
.manage-indirect-channel>>>.vs-popup {
    /* min-height: 30% !important; */
    min-width: 65% !important;
}
</style>